import classNames from 'classnames'
import React from 'react'

import styles from './Jump.css'

export type JumpProps = {
  children?: React.ReactNode
  className?: string
  'data-testid'?: string
  disabled?: boolean
  hash: number | string
}

export const Jump = ({
  children,
  className,
  'data-testid': dataTestId = 'components-elements-jump',
  disabled = false,
  hash,
}: JumpProps) => {
  const handleClick = React.useCallback<EH<'a', 'onClick'>>(() => {
    if (!disabled) {
      document.getElementById(`${hash}`)?.scrollIntoView({ behavior: 'smooth' })
    }
  }, [disabled, hash])

  return (
    <a
      className={classNames(
        styles.root,
        { [styles.disabled]: disabled },
        className,
      )}
      data-testid={dataTestId}
      onClick={handleClick}
    >
      {children}
    </a>
  )
}
